import React, { useState, useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _, { isEmpty } from 'lodash';

import { postSmsFlag, updateSmsWatchList } from '@/api/PDP';
import Switch from '@mui/material/Switch';
import { saveUserSmsOptInFlag } from "@/api/myProfile";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
// import {
//   fetchPDPInitialLoad,
//   fetchPDPBidCenterData,
//   fetchPDPLatestBidCenterData,
// } from "@/redux/PDP/pdpSlice";
import { trackButtonClick } from '@/utils/analytics';
import { getUserProfile } from "@/api/myProfile";
import { setProfileInfo } from "@/redux/user/userSlice";

const AlertRegister = ({ cmsData, isForeclosure, propertyWatchStatus, propertyId, isUserLoggedIn: isUserLoggedInProp }) => {

  const userData = useSelector(state => state.auth.registration);
  const userProfileData = useSelector((state) => state?.user.user);
  const isUserLoggedIn = useSelector((state) => state.user.isUserLoggedIn);

  const profiledata = useSelector(state => state.user.profiledata);
  const smsOptInStatus = userProfileData?.smsOptInFlag//_.get(profiledata, 'userDetails.smsOptInStatus', '');

  const phoneNumber = userProfileData?.primaryPhone//_.get(userData, 'user.primaryPhone', null);
  const [toggle, setToggle] = useState(isForeclosure
    ? propertyWatchStatus : (smsOptInStatus === 'Y') ? true : false);
  const [phoneNo, setPhoneNo] = useState(userProfileData?.primaryPhone);
  const [smsOptIn, setSmsOptIn] = useState(smsOptInStatus);


  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const user_info = useSelector((state) => state?.user?.user);

  const dispatch = useDispatch();


  const turnOn = status => {
    const emailId = _.get(userData, 'user.userEmailId', null);
    const phone = phoneNo;
    if (emailId) {
      if (status) {

        setToggle(true);
        if (smsOptInStatus === 'Y') {

          saveUserSmsOptInFlag(({
            phoneNumber: userProfileData.primaryPhone,
            smsOptIn: 'Y'
          })).then(response => {
            if (response.status === 'SUCCESS') {


              setSmsOptIn('Y');
              getUserProfile().then((response) => {
                const data = response?.data;
                dispatch(setProfileInfo(data));
              });
            }

          });
          if (isForeclosure) {
            const body = {
              propertyId: propertyId,
              updateFlag: 'Y'
            }
            updateSmsWatchList(body).then(response => {
            });
          }
        }

      } else {


        setToggle(false);
        if (smsOptInStatus === 'Y') {

          if (isForeclosure) {
            const body = {
              propertyId: propertyId,
              updateFlag: 'N'
            }
            updateSmsWatchList(body).then(response => {
            });
          } else {

            saveUserSmsOptInFlag(({
              phoneNumber: userProfileData.primaryPhone,
              smsOptIn: 'N'
            })).then(response => {
              getUserProfile().then((response) => {
                const data = response?.data;
                dispatch(setProfileInfo(data));
              });

            });

          }
        }
      }
    } else {
      if (status) {

      } else {

      }
    }
  };

  const saveAlertRegistration = status => {
    const emailId = _.get(userData, 'user.userEmailId', null);
    const phone = phoneNo;


    const error = validatePhone(phoneNo);
    if (error) {
      return;
    }
    if (emailId) {
      if (status) {

        postSmsFlag('saveUserSmsOptInFlag', phone).then(response => {


          if (response.status === "SUCCESS") {
            setSmsOptIn('Y');
            getUserProfile().then((response) => {
              const data = response?.data;
              dispatch(setProfileInfo(data));
            });
          }

          //   dispatch(toggleAlert(true));
          //   dispatch(fetchProfileData());
          //   showToast('Alert registered successfully');
        });

        if (isForeclosure) {

          const body = {
            propertyId: propertyId,
            updateFlag: 'Y'
          }
          updateSmsWatchList(body).then(response => {
          });
        }


      } else {

        postSmsFlag('saveUserSmsOptOutFlag', phone).then(response => {
          //   dispatch(toggleAlert(false));
          //   dispatch(fetchProfileData());
          //   showToast('Alert unsubscribed successfully');
        });

        if (isForeclosure) {

          const body = {
            propertyId: propertyId,
            updateFlag: 'N'
          }
          updateSmsWatchList(body).then(response => {
          });
        }

      }
    } else {
      if (status) {
        //dispatch(setAfterSignInScreen('PDP'));

      } else {

      }
    }

  }
  useEffect(() => {
    if (smsOptInStatus) {
      if (userData && smsOptInStatus === 'Y') {
        turnOn(true);
      }
    } else {
      if (userData && smsOptInStatus === 'N') {
        turnOn(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smsOptInStatus]);

  // Reset toggle when user logs out
  useEffect(() => {
    if (!isUserLoggedIn) {
      setToggle(false);
      setSmsOptIn(smsOptInStatus);

    } else if (isUserLoggedIn && isForeclosure) {
      setToggle(propertyWatchStatus);
    } else if (isUserLoggedIn && smsOptInStatus === 'Y') {
      setToggle(true);
    }
  }, [isUserLoggedIn, propertyWatchStatus, smsOptInStatus, isForeclosure]);

  const handleChange = async (event) => {


    if (!user_info || user_info === null || isEmpty(user_info)) {
      dispatch(setLoginModal(true));
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("Popup"));
    } else {

      setToggle(event.target.checked);

      trackButtonClick({
        eventName: "opt_for_sms_toggle",
        eventParams: { opt_status: event.target.checked ? "in" : "out" },
        eventCategory: "NEW-PDP",
        eventSource: "on toggle button click",
      })
    }

  };
  const validatePhone = text => {
    const number = text ? text : phoneNo ? phoneNo : userProfileData?.primaryPhone;
    let isError = false;
    var format = /^\d{10}$/;
    if (format.test(number)) {
      isError = false;
    } else {
      isError = true;
    }
    if (isError) {
      setPhoneNumberError('Invalid Phone Number');
    } else {
      setPhoneNumberError('');
    }

    // if (number?.length === 10 && !isError && isPhoneVerificationNeededAgent) {
    //   verifyAgentPhoneNumber(number);
    // }

    if (number?.length < 10 || number === undefined) {
      if (number?.length === 0 || number === undefined || number === null) {
        setPhoneNumberError('This field is required');
        isError = true;
      } else {
        setPhoneNumberError('Invalid Phone Number');
        isError = true;
      }
    }
    return isError;

  };

  const handleSave = async () => {

    const isvalidNo = validatePhone();
    if (!isvalidNo)

      saveUserSmsOptInFlag(({
        phoneNumber: phoneNo,
        smsOptIn: 'Y'
      })).then(response => {
        //  dispatch(fetchPDPInitialLoad(propertyId));
        setSmsOptIn("Y");

        getUserProfile().then((response) => {
          const data = response?.data;
          dispatch(setProfileInfo(data));
        });

        trackButtonClick({
          eventName: "opt_in_for_sms_pdp_saved",
          eventCategory: "NEW-PDP",
          eventSource: "on save button click",
        })


      });
    if (isForeclosure) {
      const body = {
        propertyId: propertyId,
        updateFlag: 'Y'
      }
      updateSmsWatchList(body).then(response => {
      });
    }



  }
  const highlighted = cmsData?.phoneConsentSection?.consentTerms.replace(
    /Terms & Conditions/i,
    '<span style="color: #1D83BE;">Terms & Conditions</span>'
  );

  return (


    smsOptInStatus !== 'Y' ?
      <div className='left_side_widget'>
        {/* <div className='pdpGenericContainer' style={{ paddingLeft: 15 }}> */}
        <ol className="">
          <li className="list-group-item d-flex justify-content-between align-items-start">
            <div className="me-auto">
              <div className="pdpHeadingMedium">Receive alerts</div>
              <p className='pdpTextDescriptionBlack m0'>Stay up-to-date on this property.</p>
            </div>
            <div className="mrm-12">
              <Switch
                checked={toggle}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'Receive property alerts' }}
              />
            </div>
          </li>
        </ol>


        <div>

          <div>

          </div>

          {(toggle && (smsOptInStatus !== 'Y' && smsOptIn !== 'Y') ?
            (<><div className='row'>
              <ol className="">
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="col-8">
                    <input
                      placeholder={'Enter your phone number'}
                      className="form-control alertTextBox"
                      maxLength={10}
                      defaultValue={userProfileData?.primaryPhone}
                      error={phoneNumberError}
                      keyboardType="numeric"
                      onBlur={() => {
                        const isValid = /^\d{10}$/.test(phoneNo);
                        setPhoneNumberError(!isValid);
                        validatePhone();
                      }}

                      ///^\d{10}$/

                      value={phoneNo}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                        if (value.length <= 10) {
                          setPhoneNo(value);
                        }
                      }}
                    />
                    {phoneNumberError.length > 0 && (
                      <div className="error-generic">
                        {phoneNumberError}
                      </div>
                    )}
                  </div>



                  <div className="">
                    <button className="btn hubzu-btn-thm alertSaveBtn" type=""
                      onClick={handleSave}>
                      Save
                    </button>
                  </div>

                </li>
              </ol>
            </div>

            </>)
            : null)}

          {toggle ?

            <div className='pl10'>
              <p className='alertTnC' dangerouslySetInnerHTML={{ __html: highlighted }} />
            </div>

            : null}

          {/* </div> */}
        </div>
      </div>

      :
      null


  );


};

export default memo(AlertRegister);

